function base64urlToArrayBuffer(base64url) {
  const padding = "=".repeat((4 - (base64url.length % 4)) % 4);
  const base64 = (base64url + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const bytes = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) bytes[i] = raw.charCodeAt(i);
  return bytes.buffer;
}

function arrayBufferToBase64url(buf) {
  const bytes = new Uint8Array(buf);
  let str = "";
  for (let i = 0; i < bytes.length; i++) str += String.fromCharCode(bytes[i]);
  const base64 = btoa(str);
  return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}

export function decodeRequestOptions(publicKey) {
  return {
    ...publicKey,
    challenge: base64urlToArrayBuffer(publicKey.challenge),
    allowCredentials: (publicKey.allowCredentials || []).map((c) => ({
      ...c,
      id: base64urlToArrayBuffer(c.id),
    })),
  };
}

export function encodeAssertion(cred) {
  return {
    id: cred.id,
    rawId: arrayBufferToBase64url(cred.rawId),
    type: cred.type,
    response: {
      authenticatorData: arrayBufferToBase64url(cred.response.authenticatorData),
      clientDataJSON: arrayBufferToBase64url(cred.response.clientDataJSON),
      signature: arrayBufferToBase64url(cred.response.signature),
      userHandle: cred.response.userHandle ? arrayBufferToBase64url(cred.response.userHandle) : null,
    },
  };
}

export function decodeCreationOptions(publicKey) {
  return {
    ...publicKey,
    challenge: base64urlToArrayBuffer(publicKey.challenge),
    user: {
      ...publicKey.user,
      id: base64urlToArrayBuffer(publicKey.user.id),
    },
    excludeCredentials: (publicKey.excludeCredentials || []).map((c) => ({
      ...c,
      id: base64urlToArrayBuffer(c.id),
    })),
  };
}

export function encodeAttestation(cred) {
  return {
    id: cred.id,
    rawId: arrayBufferToBase64url(cred.rawId),
    type: cred.type,
    response: {
      clientDataJSON: arrayBufferToBase64url(cred.response.clientDataJSON),
      attestationObject: arrayBufferToBase64url(cred.response.attestationObject),
    },
    // optional:
    clientExtensionResults: cred.getClientExtensionResults
      ? cred.getClientExtensionResults()
      : {},
  };
}